var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4176_15164",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 1,
    width: 28,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 3.67188C6.66406 2.56731 7.55949 1.67188 8.66406 1.67188H22.5023C23.0327 1.67188 23.5414 1.88259 23.9165 2.25766L32.7449 11.0861C33.12 11.4612 33.3307 11.9699 33.3307 12.5003V36.3385C33.3307 37.4431 32.4353 38.3385 31.3307 38.3385H8.66406C7.55949 38.3385 6.66406 37.4431 6.66406 36.3385V3.67188Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4176_15164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66406 3.67188C6.66406 2.56731 7.55949 1.67188 8.66406 1.67188H31.3307C32.4353 1.67188 33.3307 2.56731 33.3307 3.67188V36.3385C33.3307 37.4431 32.4353 38.3385 31.3307 38.3385H8.66406C7.55949 38.3385 6.66406 37.4431 6.66406 36.3385V3.67188Z",
    fill: "#EF3948"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3359 20.2031L24.1895 11.0567C23.8745 10.7417 24.0976 10.2031 24.543 10.2031H33.3359V20.2031Z",
    fill: "url(#paint0_linear_4176_15164)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3359 1.67188L33.3359 11.6719H25.3359C24.2314 11.6719 23.3359 10.7764 23.3359 9.67187V1.67188Z",
    fill: "#FEAAB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 29.8454V22.5391H13.9366C14.7062 22.5391 15.3159 22.749 15.7757 23.1787C16.2354 23.5985 16.4653 24.1683 16.4653 24.8779C16.4653 25.5875 16.2354 26.1573 15.7757 26.577C15.3159 27.0068 14.7062 27.2167 13.9366 27.2167H12.6972V29.8454H10.8281ZM12.6972 25.6276H13.7267C14.0065 25.6276 14.2264 25.5676 14.3764 25.4277C14.5263 25.2977 14.6063 25.1178 14.6063 24.8779C14.6063 24.6381 14.5263 24.4582 14.3764 24.3282C14.2265 24.1883 14.0066 24.1283 13.7267 24.1283H12.6972V25.6276ZM17.2349 29.8454V22.5391H19.8236C20.3334 22.5391 20.8131 22.609 21.2629 22.759C21.7126 22.9089 22.1225 23.1188 22.4823 23.4087C22.8421 23.6885 23.132 24.0683 23.3419 24.5481C23.5417 25.0278 23.6517 25.5776 23.6517 26.1972C23.6517 26.807 23.5418 27.3567 23.3419 27.8364C23.132 28.3162 22.8421 28.696 22.4823 28.9758C22.1224 29.2657 21.7126 29.4756 21.2629 29.6255C20.8131 29.7754 20.3334 29.8454 19.8236 29.8454H17.2349ZM19.064 28.2562H19.6037C19.8936 28.2562 20.1634 28.2263 20.4133 28.1563C20.6532 28.0863 20.8831 27.9763 21.103 27.8264C21.3129 27.6765 21.4828 27.4666 21.6027 27.1868C21.7227 26.9069 21.7826 26.577 21.7826 26.1972C21.7826 25.8074 21.7227 25.4776 21.6027 25.1978C21.4828 24.9179 21.3129 24.708 21.103 24.5581C20.8831 24.4082 20.6532 24.2982 20.4133 24.2283C20.1634 24.1583 19.8936 24.1283 19.6037 24.1283H19.064V28.2562ZM24.5913 29.8454V22.5391H29.7887V24.1283H26.4603V25.2977H29.119V26.8769H26.4603V29.8454H24.5913Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_15164",
    x1: 28.3359,
    y1: 20.2031,
    x2: 28.3359,
    y2: 9.99479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED2132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B31A26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.726e57914775bcdc6bc54b739f54ab71.svg";
export { ForwardRef as ReactComponent };